<template>
  <span class="text-color-0 font-700">
    <span class="whitespace-pre">
      {{ Utils.$formatMoney(value, float).integerPart }}
      <span class="text-color-2">{{
        Utils.$formatMoney(value, float).decimalPart
      }}</span>
    </span>
  </span>
</template>
<script setup>
import Utils from "@/utils/util";
const props = defineProps({
  value: {
    type: [Number, String],
    default: 0,
  },
  float: {
    type: Boolean,
    default: true,
  },
});
</script>